import { render, staticRenderFns } from "./CampaignStatus.vue?vue&type=template&id=5b430c4d&scoped=true"
import script from "./CampaignStatus.vue?vue&type=script&lang=ts"
export * from "./CampaignStatus.vue?vue&type=script&lang=ts"
import style0 from "./CampaignStatus.vue?vue&type=style&index=0&id=5b430c4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b430c4d",
  null
  
)

export default component.exports